/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiResponseOfContentResponse } from '../model';
// @ts-ignore
import { ApiResponseOfReverseOrderResponseArray } from '../model';
// @ts-ignore
import { ContentPatchBody } from '../model';
/**
 * ContentServiceApi - axios parameter creator
 * @export
 */
export const ContentServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/contentService/reverseOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a content in Content Service.
         * @param {string} contentId 
         * @param {ContentPatchBody} contentPatchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch: async (contentId: string, contentPatchBody: ContentPatchBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'contentId' is not null or undefined
            assertParamExists('patch', 'contentId', contentId)
            // verify required parameter 'contentPatchBody' is not null or undefined
            assertParamExists('patch', 'contentPatchBody', contentPatchBody)
            const localVarPath = `/api/v1/contentService/{contentId}`
                .replace(`{${"contentId"}}`, encodeURIComponent(String(contentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contentPatchBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentServiceApi - functional programming interface
 * @export
 */
export const ContentServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContentServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfReverseOrderResponseArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates a content in Content Service.
         * @param {string} contentId 
         * @param {ContentPatchBody} contentPatchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patch(contentId: string, contentPatchBody: ContentPatchBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfContentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patch(contentId, contentPatchBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContentServiceApi - factory interface
 * @export
 */
export const ContentServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContentServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: any): AxiosPromise<ApiResponseOfReverseOrderResponseArray> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a content in Content Service.
         * @param {string} contentId 
         * @param {ContentPatchBody} contentPatchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch(contentId: string, contentPatchBody: ContentPatchBody, options?: any): AxiosPromise<ApiResponseOfContentResponse> {
            return localVarFp.patch(contentId, contentPatchBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContentServiceApi - interface
 * @export
 * @interface ContentServiceApi
 */
export interface ContentServiceApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentServiceApiInterface
     */
    getAll(options?: any): AxiosPromise<ApiResponseOfReverseOrderResponseArray>;

    /**
     * Updates a content in Content Service.
     * @param {string} contentId 
     * @param {ContentPatchBody} contentPatchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentServiceApiInterface
     */
    patch(contentId: string, contentPatchBody: ContentPatchBody, options?: any): AxiosPromise<ApiResponseOfContentResponse>;

}

/**
 * ContentServiceApi - object-oriented interface
 * @export
 * @class ContentServiceApi
 * @extends {BaseAPI}
 */
export class ContentServiceApi extends BaseAPI implements ContentServiceApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentServiceApi
     */
    public getAll(options?: any) {
        return ContentServiceApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a content in Content Service.
     * @param {string} contentId 
     * @param {ContentPatchBody} contentPatchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentServiceApi
     */
    public patch(contentId: string, contentPatchBody: ContentPatchBody, options?: any) {
        return ContentServiceApiFp(this.configuration).patch(contentId, contentPatchBody, options).then((request) => request(this.axios, this.basePath));
    }
}
